'use client';
import { jsx } from 'react/jsx-runtime';
import { Stack, Link, Typography } from '@mui/material';
import { useMediaQueries } from '../../../hooks/use-media-queries/use-media-queries.js';
import styles from './app-footer-texts.module.scss.js';

const AppFooterTexts = ({ testId = undefined, texts = [] }) => {
    const mediaQuery = useMediaQueries();
    return (jsx(Stack, { className: styles.AppFooterTexts, "data-testid": testId, direction: mediaQuery.md ? 'row' : 'column', children: texts.map(({ label, onClick }) => onClick ? (jsx(Link, { className: styles.textLink, color: "inherit", "data-testid": testId && `${testId}-${label}`, onClick: onClick, underline: "none", variant: "caption", children: label }, label)) : (jsx(Typography, { "data-testid": testId && `${testId}-${label}`, variant: "caption", children: label }, label))) }));
};

export { AppFooterTexts };
